import { render, staticRenderFns } from "./online-orders.vue?vue&type=template&id=31dec3c1"
import script from "./online-orders.vue?vue&type=script&lang=js"
export * from "./online-orders.vue?vue&type=script&lang=js"
import style0 from "./online-orders.vue?vue&type=style&index=0&id=31dec3c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports